import React, {Component} from 'react'
import Link from 'gatsby-link'
import {Header} from '../components/Header'
import {Footer} from '../components/Footer'
import {InfoSection} from '../components/InfoSection/'
import {Endorsements} from '../components/Endorsements'
import {Location} from '../components/Location'
import {Contact} from '../components/Contact'
import logoSrc from '../../static/logo_color.png'
import './about.css'

import locale from '../locale'
import en from '../data-en'
import cn from '../data-cn'
let data = { en, cn };
let localizedData = () => data[locale.getLocale()];
let about_page = localizedData().about_page;

class AboutPage extends Component {
  render() {
    return (
      <div>

        <Header src={logoSrc} data={localizedData().header}></Header>

        <div className="margin-large">

          <InfoSection
            title = {about_page.overview.title}
            description = {about_page.overview.description}
            sizes = {this.props.data.enteringCarnegieImage.sizes}></InfoSection>

          <hr></hr>

          <Endorsements data = {about_page.endorsements}></Endorsements>

          <hr></hr>

          <Location data = {about_page.location}></Location>

          <hr></hr>

          <Contact data = {about_page.contact}></Contact>

        </div>

        <Footer></Footer>

      </div>
    );
  }
}

export default AboutPage

export const pageQuery = graphql`
  query AboutQuery {
    enteringCarnegieImage: imageSharp(id: { regex: "/entering_carnegie/" }) {
      sizes(maxWidth: 2000 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
  }
`;



// WEBPACK FOOTER //
// ./src/pages/about.js